// extracted by mini-css-extract-plugin
var _1 = "BirdviewInfoTooltipText-moduleinfo__u1B2l FloatingTooltipContentText-moduleadditionalText__yxASO";
export { _1 as "info" }
